/* tslint:disable */

/**
 * HR Portal API
 * HR Portal API
 *
 * The version of the OpenAPI document: 0.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists } from '../runtime';
import {
    BusinessFunction,
    BusinessFunctionFromJSON,
    BusinessFunctionToJSON,
    BusinessUnit,
    BusinessUnitFromJSON,
    BusinessUnitToJSON,
    PersonnelSubarea,
    PersonnelSubareaFromJSON,
    PersonnelSubareaToJSON
} from './';

/**
 *
 * @export
 * @interface Employee
 */
export interface Employee {
    /**
     *
     * @type {string}
     * @memberof Employee
     */
    oid?: string;
    /**
     *
     * @type {string}
     * @memberof Employee
     */
    userId: string;
    /**
     *
     * @type {string}
     * @memberof Employee
     */
    empId?: string;
    /**
     *
     * @type {string}
     * @memberof Employee
     */
    username: string;
    /**
     *
     * @type {string}
     * @memberof Employee
     */
    accdomId: string;
    /**
     *
     * @type {string}
     * @memberof Employee
     */
    firstname: string;
    /**
     *
     * @type {string}
     * @memberof Employee
     */
    lastname: string;
    /**
     *
     * @type {string}
     * @memberof Employee
     */
    defaultFullname: string;
    /**
     *
     * @type {string}
     * @memberof Employee
     */
    email?: string;
    /**
     *
     * @type {string}
     * @memberof Employee
     */
    jobTitle?: string;
    /**
     *
     * @type {string}
     * @memberof Employee
     */
    managerId?: string;
    /**
     *
     * @type {string}
     * @memberof Employee
     */
    personnelArea?: string;
    /**
     *
     * @type {PersonnelSubarea}
     * @memberof Employee
     */
    personnelSubarea?: PersonnelSubarea;
    /**
     *
     * @type {string}
     * @memberof Employee
     */
    personnelSubareaValue?: string;
    /**
     *
     * @type {BusinessFunction}
     * @memberof Employee
     */
    businessFunction?: BusinessFunction;
    /**
     *
     * @type {string}
     * @memberof Employee
     */
    businessFunctionValue?: string;
    /**
     *
     * @type {BusinessUnit}
     * @memberof Employee
     */
    businessUnit?: BusinessUnit;
    /**
     *
     * @type {string}
     * @memberof Employee
     */
    businessUnitName?: string;
    /**
     *
     * @type {string}
     * @memberof Employee
     */
    businessLine?: string;
    /**
     *
     * @type {string}
     * @memberof Employee
     */
    locationCode?: string;
    /**
     *
     * @type {string}
     * @memberof Employee
     */
    country?: string;
    /**
     *
     * @type {boolean}
     * @memberof Employee
     */
    isManager?: boolean;
    /**
     *
     * @type {boolean}
     * @memberof Employee
     */
    isExternal?: boolean;
    /**
     *
     * @type {boolean}
     * @memberof Employee
     */
    isBom?: boolean;
    /**
     *
     * @type {string}
     * @memberof Employee
     */
    hrRegion?: string;
    /**
     *
     * @type {number}
     * @memberof Employee
     */
    distanceToBom?: number;
    /**
     *
     * @type {string}
     * @memberof Employee
     */
    costCenter: string;
    /**
     *
     * @type {string}
     * @memberof Employee
     */
    businessPhone?: string;
    /**
     *
     * @type {string}
     * @memberof Employee
     */
    mobilePhone?: string;
    /**
     *
     * @type {string}
     * @memberof Employee
     */
    standardWeeklyHours?: string;
    /**
     *
     * @type {number}
     * @memberof Employee
     */
    agreedWeeklyHours?: number;
    /**
     *
     * @type {number}
     * @memberof Employee
     */
    workingDaysPerWeek?: number;
    /**
     *
     * @type {number}
     * @memberof Employee
     */
    fte?: number;
    /**
     *
     * @type {boolean}
     * @memberof Employee
     */
    isFulltimeEmployee?: boolean;
    /**
     *
     * @type {boolean}
     * @memberof Employee
     */
    onLeave?: boolean;
    /**
     *
     * @type {string}
     * @memberof Employee
     */
    companyCode?: string;
    /**
     *
     * @type {string}
     * @memberof Employee
     */
    department?: string;
    /**
     *
     * @type {string}
     * @memberof Employee
     */
    departmentName?: string;
}

export function EmployeeFromJSON(json: any): Employee {
    return EmployeeFromJSONTyped(json, false);
}

export function EmployeeFromJSONTyped(json: any, _: boolean): Employee {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {

        'oid': !exists(json, 'oid') ? undefined : json['oid'],
        'userId': json['user_id'],
        'empId': !exists(json, 'emp_id') ? undefined : json['emp_id'],
        'username': json['username'],
        'accdomId': json['accdom_id'],
        'firstname': json['firstname'],
        'lastname': json['lastname'],
        'defaultFullname': json['default_fullname'],
        'email': !exists(json, 'email') ? undefined : json['email'],
        'jobTitle': !exists(json, 'job_title') ? undefined : json['job_title'],
        'managerId': !exists(json, 'manager_id') ? undefined : json['manager_id'],
        'personnelArea': !exists(json, 'personnel_area') ? undefined : json['personnel_area'],
        'personnelSubarea': !exists(json, 'personnel_subarea') ? undefined : PersonnelSubareaFromJSON(json['personnel_subarea']),
        'personnelSubareaValue': !exists(json, 'personnel_subarea_value') ? undefined : json['personnel_subarea_value'],
        'businessFunction': !exists(json, 'business_function') ? undefined : BusinessFunctionFromJSON(json['business_function']),
        'businessFunctionValue': !exists(json, 'business_function_value') ? undefined : json['business_function_value'],
        'businessUnit': !exists(json, 'business_unit') ? undefined : BusinessUnitFromJSON(json['business_unit']),
        'businessUnitName': !exists(json, 'business_unit_name') ? undefined : json['business_unit_name'],
        'businessLine': !exists(json, 'business_line') ? undefined : json['business_line'],
        'locationCode': !exists(json, 'location_code') ? undefined : json['location_code'],
        'country': !exists(json, 'country') ? undefined : json['country'],
        'isManager': !exists(json, 'is_manager') ? undefined : json['is_manager'],
        'isExternal': !exists(json, 'is_external') ? undefined : json['is_external'],
        'isBom': !exists(json, 'is_bom') ? undefined : json['is_bom'],
        'hrRegion': !exists(json, 'hr_region') ? undefined : json['hr_region'],
        'distanceToBom': !exists(json, 'distance_to_bom') ? undefined : json['distance_to_bom'],
        'costCenter': json['cost_center'],
        'businessPhone': !exists(json, 'business_phone') ? undefined : json['business_phone'],
        'mobilePhone': !exists(json, 'mobile_phone') ? undefined : json['mobile_phone'],
        'standardWeeklyHours': !exists(json, 'standard_weekly_hours') ? undefined : json['standard_weekly_hours'],
        'agreedWeeklyHours': !exists(json, 'agreed_weekly_hours') ? undefined : json['agreed_weekly_hours'],
        'workingDaysPerWeek': !exists(json, 'working_days_per_week') ? undefined : json['working_days_per_week'],
        'fte': !exists(json, 'fte') ? undefined : json['fte'],
        'isFulltimeEmployee': !exists(json, 'is_fulltime_employee') ? undefined : json['is_fulltime_employee'],
        'onLeave': !exists(json, 'on_leave') ? undefined : json['on_leave'],
        'companyCode': !exists(json, 'company_code') ? undefined : json['company_code'],
        'department': !exists(json, 'department') ? undefined : json['department'],
        'departmentName': !exists(json, 'department_name') ? undefined : json['department_name'],
    };
}

export function EmployeeToJSON(value?: Employee | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {

        'oid': value.oid,
        'user_id': value.userId,
        'emp_id': value.empId,
        'username': value.username,
        'accdom_id': value.accdomId,
        'firstname': value.firstname,
        'lastname': value.lastname,
        'default_fullname': value.defaultFullname,
        'email': value.email,
        'job_title': value.jobTitle,
        'manager_id': value.managerId,
        'personnel_area': value.personnelArea,
        'personnel_subarea': PersonnelSubareaToJSON(value.personnelSubarea),
        'personnel_subarea_value': value.personnelSubareaValue,
        'business_function': BusinessFunctionToJSON(value.businessFunction),
        'business_function_value': value.businessFunctionValue,
        'business_unit': BusinessUnitToJSON(value.businessUnit),
        'business_unit_name': value.businessUnitName,
        'business_line': value.businessLine,
        'location_code': value.locationCode,
        'country': value.country,
        'is_manager': value.isManager,
        'is_external': value.isExternal,
        'is_bom': value.isBom,
        'hr_region': value.hrRegion,
        'distance_to_bom': value.distanceToBom,
        'cost_center': value.costCenter,
        'business_phone': value.businessPhone,
        'mobile_phone': value.mobilePhone,
        'standard_weekly_hours': value.standardWeeklyHours,
        'agreed_weekly_hours': value.agreedWeeklyHours,
        'working_days_per_week': value.workingDaysPerWeek,
        'fte': value.fte,
        'is_fulltime_employee': value.isFulltimeEmployee,
        'on_leave': value.onLeave,
        'company_code': value.companyCode,
        'department': value.department,
        'department_name': value.departmentName,
    };
}
